export const NAMESPACE = {
  selectorOverlayPart: '.b-card__block-overlay_part',
  selectorOverlayFull: '.b-card__block-overlay_full',
  classNameOverlayActive: 'b-card__block-overlay_active',
} as const
